<script>
import UploadList from "@/views/components/uploadList.vue";
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  UPLOAD_IMG_TYPE,
  MEDIA_TYPE,
  NEWS_TYPE
} from "@/utils/enumUtile";
import { getNewDetail, editNews, getAuthorList } from "@/api/news";
import { uploadImage } from "@/api/common";
import { Message } from "element-ui";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  name: "addOrEditProduct",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    MEDIA_TYPE() {
      return MEDIA_TYPE;
    },
    NEWS_TYPE() {
      return NEWS_TYPE;
    }
  },
  components: { UploadList, quillEditor },
  data() {
    return {
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "change" }],
        type: [{ required: true, message: "类型不能为空", trigger: "change" }],
        authorName: [
          { required: true, message: "作者名称不能为空", trigger: "change" }
        ],
        mediaType: [
          { required: true, message: "媒体类型不能为空", trigger: "change" }
        ],
        content: [
          { required: true, message: "资讯内容不能为空", trigger: "change" }
        ]
      },
      form: {
        id: null,
        title: null,
        type: null,
        authorName: null,
        mediaType: null,
        content: null,
        subTitle: null,
        coverImage: null,
        authorId: null,
        authorUrl: null
      },
      btnLoading: false,
      authorList: [],
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rt1" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"]
            ],
            handlers: {
              //此处是图片上传时候需要使用到的
              image: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              upload: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                }
              }
            }
          },
          clipboard: {
            // 剪切板事件
            matchers: [
              ["img", this.handlePasteImg] // 匹配图片剪切板
            ]
          }
        }
      }
    };
  },
  created() {},
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.form.id = id;
      this.getById();
      this.getAuthorList();
    }
  },
  methods: {
    /**
     * 返回列表
     */
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回新闻列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/businessNews/list" });
      });
    },
    /**
     * 查询编辑详情
     */
    getById() {
      getNewDetail({ id: this.form.id }).then(resp => {
        if (resp.bizcode === 100) {
          const data = resp.data;
          this.form = {
            id: data.id,
            type: data.type,
            title: data.title,
            subTitle: data.subTitle,
            status: data.status,
            mediaType: data.mediaType,
            content: data.content,
            authorName: data.name,
            authorId: data.authorId
          };
          // 主图地址
          if (data.coverImage) {
            const attDataArr = [];
            attDataArr.push({
              url: data.coverImage,
              dbUrl: data.coverImage,
              name: getFileName(data.coverImage)
            });
            this.form.coverImage = attDataArr;
          }
          // 商品图地址
          if (data.avatar_url) {
            const attDataArr = [];
            const defImgArr = data.avatar_url.split(",");
            defImgArr.map(item => {
              attDataArr.push({
                url: item,
                dbUrl: item,
                name: getFileName(item)
              });
            });
            this.form.authorUrl = attDataArr;
          }
        }
      });
    },

    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "coverImage") {
        this.form.coverImage = value;
      } else if (type === "authorUrl") {
        this.form.authorUrl = value;
      }
    },

    /**
     * 添加 or 编辑 商品
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            ...form
          };
          if (form.coverImage && form.coverImage.length !== 0) {
            const urlArr = form.coverImage.map(obj => obj["dbUrl"]);
            params.coverImage = urlArr.join(",");
          }
          if (form.authorUrl && form.authorUrl.length !== 0) {
            const urlArr = form.authorUrl.map(obj => obj["dbUrl"]);
            params.authorUrl = urlArr.join(",");
          }

          if (!form.id || form.id === 0) {
            delete form.id;
          }
          this.btnLoading = true;
          editNews(params)
            .then(res => {
              if (res && res.bizcode === 100) {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                this.$router.push({ path: "/businessNews/list" });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },

    handlePasteImg: function(node, delta) {
      // 调整为上传，给回路径
      let _self = this;
      let base64code =
        delta &&
        delta.ops &&
        delta.ops[0] &&
        delta.ops[0]["insert"] &&
        delta.ops[0]["insert"]["image"]; // 2.1
      if (
        base64code &&
        base64code.indexOf("http://") !== 0 &&
        base64code.indexOf("https://") !== 0
      ) {
        // 已经上传的不处理，可自定义判断逻辑
        let file = _self.dataURLtoFile(base64code, "paste.png"); // 2.2
        const params = {
          type: UPLOAD_IMG_TYPE.NEWS,
          file: file
        };
        // 调用后端服务器的接口
        uploadImage(params)
          .then(resp => {
            if (resp.bizcode === 100) {
              // 获取富文本对象
              let quill = _self.$refs["myQuillEditor"].quill;
              let length = quill.selection.savedRange.index;
              quill.insertEmbed(length, "image", resp.data.dbUrl);
              quill.setSelection(length + 1);
            } else {
              Message({
                message: resp.msg,
                type: "error",
                duration: 3 * 1000
              });
            }
          })
          .catch(e => {
            this.$message.error(e.message);
            this.$refs.upload.clearFiles();
          })
          .finally(() => {
            this.loading = false;
          });
        // 1、等待请求返回做不到同步，先返回空，在请求回调中再添加（这里监听函数接收职能接收同步的数据，特殊处理）
        delta.ops = [];
        return delta;
      } else {
        return delta;
      }
    },
    // 图片的base64编码转为图片文件
    dataURLtoFile: function(dataurl, name) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },

    // 上传详情里的图片
    handleFileUpload(file, index, iIndex) {
      const then_ = this;
      this.loading = true;
      const params = {
        type: UPLOAD_IMG_TYPE.NEWS,
        file: file.file
      };
      // 调用后端服务器的接口
      uploadImage(params)
        .then(resp => {
          if (resp.bizcode === 100) {
            let quill = then_.$refs.myQuillEditor.quill;
            let length = quill.getSelection().index;
            quill.insertEmbed(length, "image", resp.data.dbUrl);
            quill.setSelection(length + 1);
          } else {
            Message({
              message: resp.msg,
              type: "error",
              duration: 3 * 1000
            });
          }
        })
        .catch(e => {
          this.$message.error(e.message);
          this.$refs.upload.clearFiles();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 查询作者
     */
    getAuthorList(query) {
      const params = {
        name: query,
        page: 1,
        pageSize: 99
      };
      getAuthorList(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.authorList = resp.data.entitys;
        }
      });
    },
    /**
     * 改变作者
     */
    authorChange(selVal) {
      const selObj = this.authorList.find(item => item.id === selVal);
      if (selObj && Object.keys(selObj).length !== 0) {
        this.form.authorName = selObj.name;
        // 主图地址
        if (selObj.avatarUrl) {
          const attDataArr = [];
          attDataArr.push({
            url: selObj.avatarUrl,
            dbUrl: selObj.avatarUrl,
            name: getFileName(selObj.avatarUrl)
          });
          this.form.authorUrl = attDataArr;
        }
      }
      console.log("selObj222", selObj);
    }
  }
};
</script>

<template>
  <div class="app-container add_edit_product_warp">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="150px"
      style="width: calc(100% - 100px); padding:20px 50px;"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="副标题" prop="subTitle">
        <el-input v-model="form.subTitle" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="资讯类型" prop="type">
        <el-select
          v-model="form.type"
          placeholder="类型"
          style="width: 100%"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in NEWS_TYPE"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="媒体类型" prop="mediaType">
        <el-select
          v-model="form.mediaType"
          placeholder="类型"
          style="width: 100%"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in MEDIA_TYPE"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="封面图" prop="coverImage">
        <UploadList
          :typeProps="UPLOAD_IMG_TYPE.NEWS"
          @valueFunc="getImgsValueFunc"
          paramsType="coverImage"
          :model="form.coverImage"
          :maxCount="1"
        />
      </el-form-item>

      <el-form-item
        label="资讯内容"
        prop="content"
        v-if="form.mediaType === 'TXT'"
      >
        <quill-editor
          v-model="form.content"
          class="content_warp"
          ref="myQuillEditor"
          :options="editorOption"
        ></quill-editor>
      </el-form-item>
      <el-form-item label="可搜索作者" prop="authorId">
        <el-select
          v-model="form.authorId"
          placeholder="类型"
          style="width: 100%"
          class="filter-item"
          clearable
          filterable
          remote
          :remote-method="getAuthorList"
          @change="authorChange"
        >
          <el-option
            v-for="item in authorList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
            <el-avatar
              style="float: right;"
              :src="item.avatarUrl"
              size="medium"
            ></el-avatar>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作者名称" prop="authorName">
        <el-input v-model="form.authorName" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="作者头像" prop="authorUrl">
        <UploadList
          :typeProps="UPLOAD_IMG_TYPE.NEWS"
          @valueFunc="getImgsValueFunc"
          paramsType="authorUrl"
          :model="form.authorUrl"
          :maxCount="1"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading"
        >确定</el-button
      >
    </div>
    <el-upload
      action="#"
      list-type="picture-card"
      class="uploadFile"
      :limit="1"
      :show-file-list="false"
      :http-request="handleFileUpload"
      v-show="false"
    >
    </el-upload>
  </div>
</template>

<style scoped lang="scss">
.add_edit_product_warp {
  background-color: #dcdfe642;
  padding: 20px 4%;
}
.card_but {
  margin-bottom: 20px;
  padding: 20px;
}
//规格
.specification_warp {
  background: #f7f8fa;
  padding: 10px;
  .but_left {
    margin-left: 10px;
  }
  .specification_item {
    margin-bottom: 10px;
    .specification_item_isEdit {
      display: flex;
    }
    .specification_item_i {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .specification_item_i_item {
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 20px;
        .img_ {
          height: 26px;
          width: 28px;
          border: 1px dashed #d7dbe0;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          cursor: pointer;
          img {
            width: 50%;
            height: 50%;
          }
          ::v-deep .el-upload--picture-card {
            height: 34px;
            width: 34px;
            line-height: 38px;
          }
        }
        .delete_img_ {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          cursor: pointer;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
      .add_specification_item_i_item {
        border: 1px solid rgba(61, 94, 255, 0.15);
        border-radius: 10px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
      .add_specification_item_i_item:hover {
        color: #111;
        background: #ebecf0;
        border-color: #ebecf0;
      }
    }
  }

  .add_specification_but {
    border: 1px solid rgba(61, 94, 255, 0.15);
    border-radius: 10px;
    width: 60%;
    height: 41px;
    text-align: center;
    cursor: pointer;
  }
  .add_specification_but:hover {
    color: #111;
    background: #ebecf0;
    border-color: #ebecf0;
  }
  .add_specification_but_no {
    border: 1px solid rgba(61, 94, 255, 0.15);
    cursor: not-allowed;
  }
}
@media screen and (max-width: 1980px) {
  .attribute_warp {
    width: 100%;
  }
}
@media screen and (min-width: 1980px) {
  .attribute_warp {
    width: 60%;
  }
}
.attribute_warp {
  //width: 60%;
  .attribute_table_header_warp {
    background-color: red;
  }
  .batch_warp {
    display: flex;
    margin-bottom: 10px;
  }
  .mar_left {
    margin-left: 10px;
  }
  ::v-deep .el-input__suffix {
    top: 6px;
  }
}

.dialog-footer {
  text-align: center;
}
.content_warp {
  .uploadFile {
    width: 0;
    height: 0;
    display: none;
  }
  ::v-deep {
    .ql-container {
      min-height: 400px;
    }
    .ql-editor {
      min-height: 400px;
    }
  }
}
</style>
